import React from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import OverlayController from '../overlay/OverlayController';
import ProjectSettingsDialog from '../projectSettings/ProjectSettingsDialog';
import { browserHistory } from 'react-router';

class ProjectCard extends React.Component {

    didClickSettingsButton() {
        OverlayController.showOverlay({
            component: <ProjectSettingsDialog project={this.props.project} />
        });
    }

    didClickCard() {
        browserHistory.push('/projects/' + this.props.project.id);
    }

    render() {
        return (
            <div className="project-card" onClick={this.didClickCard.bind(this)}>
                <div className="project-menu-icon-wrapper" onClick={(event) => {event.stopPropagation()}} >
                    <IconButton className="project-settings-button" onTouchTap={this.didClickSettingsButton.bind(this)}>
                        <SettingsIcon className="project-settings-icon"/>
                    </IconButton>
                </div>
                <div className="project-name">{this.props.project.name}</div>
                <div className="project-info">
                    Project ID: {this.props.project.id}
                </div>
            </div>
        );
    }
}

ProjectCard.propTypes = {
    project: PropTypes.object
};

export default ProjectCard;



// WEBPACK FOOTER //
// ./src/components/projectList/ProjectCard.js